import React from "react";
import Payment from "../../components/payment/Payment";

const PaymentPage = () => {
  return (
    <div>
      <Payment />
    </div>
  );
};

export default PaymentPage;
